module.exports = __webpack_public_path__ + "media/bootstrap-icons/info-square-fill-5a4f5248.svg";